/**
 * Mobile Search Drawer - independent of header-desktop
 * Triggers: .bottom-search-trigger
 * Reuses <predictive-search> component
 */
(function() {
	'use strict';

	var DRAWER_ID = 'mobile-search-drawer';
	var DRAWER_ACTIVE = 'active';
	var BODY_LOCK = 'mobile-search-open';
	var FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

	function MobileSearchDrawer() {
		this.drawer = document.getElementById(DRAWER_ID);
		this.trigger = null;
		this.lastFocused = null;
		this.boundHandleKeydown = this.handleKeydown.bind(this);
		this.boundHandleClose = this.close.bind(this);
	}

	MobileSearchDrawer.prototype.init = function() {
		if (!this.drawer) return;

		document.addEventListener('click', this.handleClick.bind(this));
		document.addEventListener('keydown', this.boundHandleKeydown);
		this.drawer.querySelectorAll('[data-mobile-search-close]').forEach(function(el) {
			el.addEventListener('click', this.boundHandleClose);
		}.bind(this));

		document.addEventListener('shopify:section:load', this.rebind.bind(this));
	};

	MobileSearchDrawer.prototype.handleClick = function(e) {
		if (e.target.closest('.bottom-search-trigger')) {
			e.preventDefault();
			this.open(e.target.closest('.bottom-search-trigger'));
		}
	};

	MobileSearchDrawer.prototype.open = function(triggerEl) {
		if (!this.drawer) return;

		this.trigger = triggerEl || document.querySelector('.bottom-search-trigger');
		this.lastFocused = document.activeElement;

		this.drawer.classList.add(DRAWER_ACTIVE);
		this.drawer.setAttribute('aria-hidden', 'false');
		document.body.classList.add(BODY_LOCK);

		if (this.trigger) {
			this.trigger.setAttribute('aria-expanded', 'true');
		}

		requestAnimationFrame(function() {
			var input = this.drawer.querySelector('.search__input.field__input');
			if (input) {
				input.focus();
			}
		}.bind(this));

		this.trapFocus();
	};

	MobileSearchDrawer.prototype.close = function() {
		if (!this.drawer || !this.drawer.classList.contains(DRAWER_ACTIVE)) return;

		this.drawer.classList.remove(DRAWER_ACTIVE);
		this.drawer.setAttribute('aria-hidden', 'true');
		document.body.classList.remove(BODY_LOCK);

		if (this.trigger) {
			this.trigger.setAttribute('aria-expanded', 'false');
			this.trigger.focus();
			this.trigger = null;
		} else if (this.lastFocused && this.lastFocused.focus) {
			this.lastFocused.focus();
		}

		var predictiveSearch = this.drawer.querySelector('predictive-search');
		if (predictiveSearch && typeof predictiveSearch.close === 'function') {
			predictiveSearch.close(true);
		}
	};

	MobileSearchDrawer.prototype.handleKeydown = function(e) {
		if (!this.drawer || !this.drawer.classList.contains(DRAWER_ACTIVE)) return;

		if (e.key === 'Escape') {
			e.preventDefault();
			this.close();
			return;
		}

		if (e.key !== 'Tab') return;

		var focusable = this.drawer.querySelectorAll(FOCUSABLE);
		var first = focusable[0];
		var last = focusable[focusable.length - 1];

		if (e.shiftKey) {
			if (document.activeElement === first) {
				e.preventDefault();
				last.focus();
			}
		} else {
			if (document.activeElement === last) {
				e.preventDefault();
				first.focus();
			}
		}
	};

	MobileSearchDrawer.prototype.trapFocus = function() {
		var focusable = this.drawer.querySelectorAll(FOCUSABLE);
		if (focusable.length === 0) return;

		focusable[0].addEventListener('keydown', function trapFirst(e) {
			if (e.key === 'Tab' && e.shiftKey) {
				e.preventDefault();
				focusable[focusable.length - 1].focus();
				focusable[0].removeEventListener('keydown', trapFirst);
			}
		});

		focusable[focusable.length - 1].addEventListener('keydown', function trapLast(e) {
			if (e.key === 'Tab' && !e.shiftKey) {
				e.preventDefault();
				focusable[0].focus();
				focusable[focusable.length - 1].removeEventListener('keydown', trapLast);
			}
		});
	};

	MobileSearchDrawer.prototype.rebind = function() {
		this.drawer = document.getElementById(DRAWER_ID);
	};

	var instance = new MobileSearchDrawer();

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function() { instance.init(); });
	} else {
		instance.init();
	}
})();
